import { GlModal, GlSprintf } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
import HelpPageLink from '../help_page_link/help_page_link.vue?vue3';
export default {
    name: 'GroupListItemPreventDeleteModal',
    i18n: {
        title: __("Group can't be be deleted"),
        message: __("This group can't be deleted because it is linked to a subscription. To delete this group, %{linkStart}link the subscription%{linkEnd} with a different group.")
    },
    components: {
        GlModal,
        GlSprintf,
        HelpPageLink
    },
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        modalId: {
            type: String,
            required: true
        }
    },
    emits: [
        'change'
    ],
    CANCEL_PROPS: {
        text: __('Cancel')
    }
};
